export default __webpack_public_path__ + "static/media/pexels-photo-48566-750x490.49c1c861.jpeg";